const url = 'payment-history-service/v1/bank-muscat/payment-request-status'
export const getPaymentRequestStatus = (pageNumber: number = 0, pageSize: number = 10, fromDate: string, toDate: string, paymentStatus: string, billNumber: string) => {
    return {
        url: `${url}?pageNumber=${pageNumber}&pageSize=${pageSize}&fromDate=${fromDate}&toDate=${toDate}&paymentStatus=${paymentStatus||''}&billNumber=${billNumber||''}`,
        method: 'GET',
    };
};